import type {
  Validations,
  ChatbotWhatsappState,
  ChatbotWhatsappApi,
} from 'src/types/chatbot-whatsapp';
import {
  normalizeNodeSchedule,
  parseNodeSchedule,
} from 'src/utils/node-schedule';


export const parseChatbotWhatsapp = (
  fetchedNodeResponse: ChatbotWhatsappApi,
): ChatbotWhatsappState => {
  const chatbotWhatsappParams = fetchedNodeResponse.task.params;
  const nodeSchedule = parseNodeSchedule(fetchedNodeResponse);

  const toNumber = chatbotWhatsappParams.to_number;
  if (toNumber == null) {
    throw new Error(
      'to_number field should be present in chatbot whatsapp node response',
    );
  }

  return {
    flow_id: chatbotWhatsappParams.flow_id,
    to_number:
      toNumber.startsWith('{{') && toNumber.endsWith('}}')
        ? toNumber
        : `{{${toNumber}}}`,
    ...nodeSchedule,
  };
};

export const normalizeChatbotWhatsapp = (
  payload: ChatbotWhatsappState,
): ChatbotWhatsappApi => {
  const {to_number, flow_id} = payload;
  const nodeSchedule = normalizeNodeSchedule(payload);
  return {
    task: {
      params: {
        to_number,
        flow_id,
      },
    },
    ...nodeSchedule,
  };
};

export const getErrors = (validationsObject: Validations): Array<string> => {
  const errors: Array<string> = [];
  const {sendToNumberEmpty, invalidToNumber} = validationsObject;
  if (sendToNumberEmpty) {
    errors.push('Please fill the required fields.');
  }
  if (invalidToNumber) {
    errors.push('Send to number is Invalid.');
  }
  return errors;
};
